import { getSession } from '../auth';
import { listCourses, listBatches, listStudents, listLeads } from '../lib/repository';

let counts: { courses: number; batches: number; students: number; leads: number } | null = null;
let leadPreview: Array<{ id: string; name: string; status: string; phone?: string }> = [];
let loading = false;

function load(): void {
  if (counts || loading) return;
  loading = true;
  Promise.all([listCourses().catch(() => []), listBatches().catch(() => []), listStudents().catch(() => []), listLeads().catch(() => [])])
    .then(([c, b, s, l]) => {
      counts = { courses: c.length, batches: b.length, students: s.length, leads: l.length };
      leadPreview = l.slice(0, 4).map((x) => ({ id: x.id, name: x.name || '—', status: x.status || 'new', phone: x.phone || '' }));
      loading = false;
      (window as any).__rerender?.();
    })
    .catch(() => { loading = false; });
}

function stageLabel(s: string): string {
  return { new: 'New', contacted: 'Contacted', qualified: 'Qualified', won: 'Won', lost: 'Lost' }[s] || s;
}

export function renderOverview(): string {
  load();
  const session = getSession();
  const name = session?.name || '—';
  const c = counts || { courses: 0, batches: 0, students: 0, leads: 0 };
  const firstName = name.split(' ')[0];

  const kpis = [
    { label: 'Courses', value: c.courses, tone: 'kpi-tone-1', emoji: '📚', route: '#/courses' },
    { label: 'Batches', value: c.batches, tone: 'kpi-tone-2', emoji: '🗓', route: '#/batches' },
    { label: 'Students', value: c.students, tone: 'kpi-tone-3', emoji: '🎓', route: '#/students' },
    { label: 'Leads', value: c.leads, tone: 'kpi-tone-4', emoji: '⚡', route: '#/leads-inbox' },
  ];
  const kpiCards = kpis.map((k) =>
    '<a class="kpi-card ' + k.tone + ' touch-target" href="' + k.route + '" data-no-prop>' +
      '<span class="kpi-emoji">' + k.emoji + '</span>' +
      '<span class="kpi-num">' + (loading ? '…' : k.value) + '</span>' +
      '<span class="kpi-label">' + k.label + '</span></a>'
  ).join('');

  const leadRows = leadPreview.length ? leadPreview.map((l) => (
    '<div class="mini-row"><div class="avatar av-c1">' + (l.name || '?').slice(0, 2).toUpperCase() + '</div>' +
    '<div style="flex:1;min-width:0"><div class="t-strong">' + l.name + '</div><div class="t-meta t-mono">' + (l.phone || '') + '</div></div>' +
    '<span class="pill pill-info">' + stageLabel(l.status) + '</span></div>'
  )).join('') : '<div class="empty" style="padding:14px 0">No leads yet — the Apply form on techtatwa.in feeds this inbox.</div>';

  const quickActions = [
    { label: '+ New course', route: '#/courses' },
    { label: '+ New batch', route: '#/batches' },
    { label: '+ Add student', route: '#/students' },
    { label: 'Whitelist email', route: '#/members' },
  ].map((q) => '<a class="quick-tile touch-target" href="' + q.route + '" data-no-prop>' + q.label + '</a>').join('');

  return (
    '<section class="hero stagger"><div>' +
      '<div class="hero-greet">Welcome back</div>' +
      '<h1 class="hero-title">' + firstName + ',<br/><span class="hero-stroke">here’s your day.</span></h1>' +
      '<p class="t-meta" style="margin-top:10px">' + (session?.tenantName || session?.tenantId || '') + ' · ' + session?.role + '</p>' +
      '</div></section>' +
      '<div class="kpi-grid stagger">' + kpiCards + '</div>' +
      '<div class="treasury-grid stagger" style="grid-template-columns:1.4fr 1fr">' +
        '<div class="card card-pad-lg"><div class="t-eyebrow" style="margin-bottom:6px">Recent leads</div>' +
        '<div class="t-h2" style="margin:4px 0 12px">Your funnel at a glance</div>' + leadRows + '</div>' +
        '<div class="card card-pad-lg"><div class="t-eyebrow" style="margin-bottom:6px">Quick actions</div>' +
        '<div class="t-h2" style="margin:4px 0 12px">Jump back in</div>' +
        '<div class="quick-grid">' + quickActions + '</div>' +
        '<div style="margin-top:18px"><a class="btn btn-accent touch-target" href="#/site-content" data-no-prop>✎ Edit public site</a>' +
        '<a class="btn btn-ghost touch-target" href="#/members" data-no-prop style="margin-left:8px">Members</a></div>' +
        '</div></div>'
  );
}
